/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { apiClient } from '../client'
import type { LoginRequest, LoginResponse, TokenResponse, UserProfile } from '@/types/auth.types'
import { getRefreshToken } from '@/lib/token'

/**
 * Přihlášení uživatele
 */
export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/api/auth/login', credentials)
  return response.data
}

/**
 * Obnovení access tokenu pomocí refresh tokenu
 */
export const refreshToken = async (): Promise<TokenResponse> => {
  const refreshTokenValue = getRefreshToken()
  if (!refreshTokenValue) {
    throw new Error('No refresh token available')
  }

  const response = await apiClient.post<TokenResponse>('/api/auth/refresh', {
    refreshToken: refreshTokenValue,
  })
  return response.data
}

/**
 * Odhlášení uživatele
 */
export const logout = async (): Promise<void> => {
  const refreshTokenValue = getRefreshToken()
  if (refreshTokenValue) {
    await apiClient.post('/api/auth/logout', {
      refreshToken: refreshTokenValue,
    })
  }
}

/**
 * Získání profilu přihlášeného uživatele
 */
export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await apiClient.get<UserProfile>('/api/user/profile')
  return response.data
}

/**
 * Aktualizace profilu přihlášeného uživatele
 */
export const updateUserProfile = async (data: Partial<UserProfile>): Promise<UserProfile> => {
  const response = await apiClient.patch<UserProfile>('/api/user/profile', data)
  return response.data
}
